import { error } from '@pressreader/logger';

export function logErrorArticlePrimaryIdMissing(articleId: string | null) {
    error(new Error(`articlePrimaryIdMissing::Article primary id missing for article id: ${articleId}`));
}
